export const searchSortValues = [
  {
    'value': 'default',
    'display': 'Relevance'
  },
  {
    'value': '^Display Name',
    'display': 'Display Name, A-Z'
  },
  {
    'value': '$Display Name',
    'display': 'Display Name, Z-A'
  },
  {
    'value': '^Reference Count',
    'display': 'Least References'
  },
  {
    'value': '$Reference Count',
    'display': 'Most References'
  },
  {
    'value': '^root_lastEdited',
    'display': 'Oldest Change'
  },
  {
    'value': '$root_lastEdited',
    'display': 'Newest Change'
  },
  {
    'value': '$root_structure_mwt',
    'display': 'Highest Molecular Weight'
  },
  {
    'value': '^root_structure_mwt',
    'display': 'Lowest Molecular Weight'
  }
];
